export const COUNTRY_FILTER_ENABLED = 'COUNTRY_FILTER_ENABLED'
export const COUNTRY_FILTER_DISABLED = 'COUNTRY_FILTER_DISABLED'

const enable = (countryFilter) => ({
  type: COUNTRY_FILTER_ENABLED,
  countryFilter,
})

const disable = () => ({
  type: COUNTRY_FILTER_DISABLED,
  countryFilter: null,
})

export const enableCountryFilter = (filter) => (dispatch) => {
  dispatch(enable(filter))
}

export const disableCountryFilter = () => (dispatch) => {
  dispatch(disable())
}
